import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const getAllPriceHistory = async () => {
  try {
    return await getData(`/website/market-price/history`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllCompanyMarketPrice = async (name) => {
  try {
    return await getData(
      `/website/market-price/company-market-price?name=${name}`
    );
  } catch (error) {
    console.log(error);
  }
};

